/* FTE Report — Details tab: the "Forecasted New Hire Report". A card with the report title and
   the month picker, then one separate table per category (Employees / IWO Employees /
   Subcontractors), each with its own header and pagination (./DetailsSectionTable.js). Pure
   presentation — fetch and month-visibility STATE live in Details.js. */
import React from "react";
import { TABLE_FONT } from "../../reportTableConfig";
import MonthColumnPicker from "./MonthColumnPicker";
import DetailsSectionTable from "./DetailsSectionTable";

export default function DetailsTable({
  sections,
  totalCount,
  allMonths,
  actualMonths,
  visibleMonths,
  hiddenMonths,
  onToggleMonth,
  onResetMonths,
}) {
  return (
    <div
      style={{
        borderRadius: 12,
        border: "1px solid #EBEBEB",
        background: "#fff",
        overflow: "hidden",
        fontFamily: TABLE_FONT,
      }}
    >
      <div
        style={{
          padding: "10px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>
          Forecasted New Hire Report
        </span>
        <MonthColumnPicker
          monthKeys={allMonths}
          hidden={hiddenMonths}
          onToggle={onToggleMonth}
          onReset={onResetMonths}
        />
      </div>
      {sections.map((section) => (
        <DetailsSectionTable
          key={section.category}
          category={section.category}
          rows={section.rows}
          visibleMonths={visibleMonths}
          actualMonths={actualMonths}
        />
      ))}
    </div>
  );
}
